import { Pipe, PipeTransform } from '@angular/core'
import { Moment } from 'moment-mini'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms'
import moment from 'moment-mini'

@Pipe({
  name: 'getSelectedDateFormGroup'
})
export class GetSelectedDateFormGroupPipe implements PipeTransform {
  constructor(private fb: UntypedFormBuilder) {}

  transform(
    datesForm: UntypedFormArray,
    selectedDate: Moment
  ): UntypedFormGroup {
    let formGroup: UntypedFormGroup
    for (const control of datesForm.controls as UntypedFormGroup[]) {
      if (
        moment(control.value['date']).format('YYYY-MM-DD') ===
        selectedDate?.format?.('YYYY-MM-DD')
      ) {
        formGroup = control
      }
    }

    if (!formGroup) {
      return this.fb.group({
        date: [null],
        products: new UntypedFormArray([])
      })
    }

    if (formGroup.invalid) {
      console.log('formGroup invalid', formGroup)
    }

    return formGroup
  }
}
